import { useNavigate } from 'react-router-dom';
import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';

import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';
import { QUESTIONNAIRES_MODALS } from '../../employee-questionnaire-settings.constants';

import { IEmployeeQuestionnaireSettingsTableRowProps } from './employee-questionnaire-settings-tableinterfaces';

const EmployeeQuestionnaireSettingsTableRowActions = ({
  record,
  handleModals,
  t,
}: IEmployeeQuestionnaireSettingsTableRowProps) => {
  const navigate = useNavigate();
  const { canDelete, canEdit } = useUserCanManageDocument({
    createdBy: record.createdBy,
    platformPermission: PLATFORM_PERMISSIONS.companySettings,
  });

  const handleEditQuestioner = () => {
    if (canEdit) {
      navigate(`${ROUTES.settings}?type=${SETTINGS_PAGES.employeeQuestionnaire}&id=${record._id}`);
    }
  };

  const handlePreviewQuestioner = () => {
    if (canEdit) {
      navigate(`${ROUTES.settings}/${SETTINGS_PAGES.questionnairePreview}?id=${record._id}`);
    }
  };

  return (
    <Popover
      elements={[
        {
          label: t('settings:documents.buttons.previewTheTemplate'),
          icon: ICONS.bookContent,
          key: ICONS.bookContent,
          handler: handlePreviewQuestioner,
        },
        {
          label: t('settings:employeeQuestionnaire.buttons.editQuestionnaire'),
          icon: ICONS.editAlt,
          key: ICONS.editAlt,
          ...(!canEdit && { color: PLATFORM_THEME_COLORS.grayVariations.murky }),
          handler: handleEditQuestioner,
        },
        {
          label: t('settings:employeeQuestionnaire.buttons.deleteQuestionnaire'),
          icon: ICONS.trash,
          color: canDelete
            ? PLATFORM_THEME_COLORS.tone.red
            : PLATFORM_THEME_COLORS.grayVariations.murky,
          key: ICONS.trash,
          handler: () => {
            if (canDelete) {
              handleModals(QUESTIONNAIRES_MODALS.delete, record);
            }
          },
        },
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default EmployeeQuestionnaireSettingsTableRowActions;
